<template>
    <div id="GalleryPreview">
        <div class="row pl-3">
            <div>
                <img :src="CDN_URL + intensGalleryPreview.items[0].image.url" alt="">
            </div>
            <div>
                <div class="extra-pictures" v-if="intensGalleryPreview.items.length > 1">
                    <span>+{{intensGalleryPreview.items.length - 1}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ImageBlock from '@/components/blocks/ImageBlock'
export default {
    name: 'GalleryPreview',
    data(){
        return{
            CDN_URL: null
        }
    },
    props:{
        intensGalleryPreview: {
            type: Object,
            required: true
        }
    },
    methods:{
        isMobile() {
            if(/Android|webOS|iPhone||iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        }
    },
    components:{
        ImageBlock
    },
    created(){
        this.CDN_URL = process.env.CDN_URL
    }
}
</script>
<style>
    #GalleryPreview img{
        width: 68px;
        height: 68px;
        border-radius: 6px;
        margin: 0 6px;
        object-fit: cover;
    }
    .extra-pictures{
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        border-radius: 6px;
        background-color: #FBFBFB;
        border: 1px silid #F6F5F5;
        height: 68px;
        width: 68px;
        margin: 0 6px;
    }
</style>




// WEBPACK FOOTER //
// src/components/blocks/GalleryPreview.vue